import customerApi from '@/services/API/customer'
import salesOrderApi from '@/services/API/sales-order'
import itemsApi from '@/services/API/items'
import controlData from '@/services/API/controlData'
import inventoryAPI from '@/services/API/inventory'
import productAPI from '@/services/API/product'
import reservationAPI from '@/services/API/reservation'
import systemAPI from '@/services/API/system';
import Promise from 'bluebird'
import salesUtils from '@/utils/sales-utils'
const uuidv1 = require('uuid/v1');
import { Message } from 'element-ui';
import { MessageBox } from 'element-ui';
import moment from 'moment'
import i18n from '../../../i18n';

//WARNING => DUPLCATED IN SalesOrders
const actionsMap = {
  save: {
    associatedStatus: 'DRAFT'
  },
  emit : {
    associatedStatus : 'TO_PROCESS'
  },
  process : {
    associatedStatus : 'IN_PROCESS'
  },
  confirm: {
    associatedStatus: 'CONFIRMED'
  },
  cancel : {
    associatedStatus: 'VOIDED'
  }
};

function formatSaveSalesOrder(salesOrder){
  let postData = {
    id: _.get(salesOrder, 'id'),
    soNumber: _.get(salesOrder, 'soNumber'),
    customer: {
      id: _.get(salesOrder, 'customer.id'),
    },
    date: _.get(salesOrder, 'date') != null ? moment(_.get(salesOrder, 'date')).format() : null,
    expectedDeliveryDate: _.get(salesOrder, 'expectedDeliveryDate') != null ? moment(_.get(salesOrder, 'expectedDeliveryDate')).format() : undefined,
    reference: _.get(salesOrder, 'reference'),
    notes: _.get(salesOrder, 'notes'),
    subTotal: _.get(salesOrder, 'subTotal'),
    total: _.get(salesOrder, 'total'),
    discount: _.get(salesOrder, 'discount') != null ?  _.get(salesOrder, 'discount') : null,
    taxes: _.get(salesOrder, 'taxes'),
    billingAddress: {
      id: _.get(salesOrder, 'billingAddress.id'),
    },
    shippingAddress: {
      id: _.get(salesOrder, 'shippingAddress.id'),
    },
    billingContact: {
      id: _.get(salesOrder, 'billingContact.id'),
    },
    shippingContact: {
      id: _.get(salesOrder, 'shippingContact.id'),
    },
    extraInfo: _.get(salesOrder, 'extraInfo'),
    lines : [],
    tags : _.get(salesOrder, 'tags'),
  };
  if (_.get(salesOrder, 'rep') === '') {
    postData.rep = null;
  } else if (_.get(salesOrder, 'rep') != null) {
    postData.rep = {
      id: _.get(salesOrder, 'rep.id'),
      firstName: _.get(salesOrder, 'rep.first_name'),
      lastName: _.get(salesOrder, 'rep.last_name'),
    };
  } 

    if (_.get(salesOrder, 'deliveryType.id') != null) {
      postData.deliveryTypes = [{
        id: _.get(salesOrder, 'deliveryType.id'),
      }]
    }

  if (_.get(salesOrder, 'rep') === '') {
    postData.rep = null;
  } else if (_.get(salesOrder, 'rep') != null) {
    postData.rep = {
      id: _.get(salesOrder, 'rep.id'),
      firstName: _.get(salesOrder, 'rep.first_name'),
      lastName: _.get(salesOrder, 'rep.last_name'),
    };
  } 

    if (_.get(salesOrder, 'deliveryType.id') != null) {
      postData.deliveryTypes = [{
        id: _.get(salesOrder, 'deliveryType.id'),
      }]
    }

  _.forEach(salesOrder.lines, item => {
    let line = {
      id: item.id,
      product: {
        id: _.get(item, 'product.id'),
        puid: _.get(item, 'product.puid'),
      },
      inventory: _.get(item, 'inventory'),
      prices : _.get(item, 'prices'),
      qty : _.get(item, 'qty'),
      discount:  _.get(item, 'discount'),
      subTotal: _.get(item, 'subTotal'),
      subTotalBrut: _.get(item, 'subTotalBrut'),
      taxes: _.get(item, 'taxes'),
    }

    if (item.reservation) {
      line.reservation = {
        id: item.reservation.id,
      }
    }

    postData.lines.push(line);
  })
  return postData;
}

const getPrice =  (inventoryId, productId, qty, customerId) =>
  inventoryAPI.getProductPriceV2(inventoryId, productId, { qty, customerId, idType: 'puid' });
const getServicePrice =  (productId, qty, customerId) =>
  productAPI.getProductPriceV2(productId, { qty, customerId, idType: 'id' });


const validate = function({state}, action){
  let validationControl = {
    date:true,
    items:true,
    quantities:true,
    delivery:true,
    billingContact:true,
    shippingContact:true
  };

  if(action!='emit'){
    validationControl.date = false;
    validationControl.items = false;
  }
  let validObject= salesUtils.validateSalesOrder(state.salesOrder, validationControl);
  let valid = true;
  _.forIn(validObject, (value, key) => { if(!value)valid=false; })
  return valid;
}

/**
 * Get the status of the sales order depending on the action executed.
 * The worklfow is:
 * NONE -> draft -> confirmed -> (invoiced | packed | shipped) -> fullfiled -> closed
 * @param {String} action
 * @param {Object} salesOrderStatuses
 * @param {Object} salesOrder
 */
function getStatusFromAction(action, salesOrderStatuses, salesOrder) {
  const saveStatus = salesOrder.status==null?salesOrderStatuses.find(s => s.code === 'DRAFT') : salesOrder.status;
  return action==='save' ? saveStatus : salesOrderStatuses.find(s => s.code === actionsMap[action].associatedStatus);
}

//Fetch customer based on a search string
const fetchSearchedCustomers = function({ commit }, query) {
  return customerApi.fetchSearchedCustomers({searchTerms:query, paging:'no', active:true}).then(searchedCustomers => {
    commit('SET_SEARCHED_CUSTOMERS', searchedCustomers);
    return searchedCustomers;
  });
};

const fetchCustomerContacts = function({ commit, state }){
  return customerApi.fetchCustomerContacts(state.salesOrder.customer.id).then(contacts=>{
    commit('SET_CUSTOMER_CONTACTS', contacts);
  })
}
//Set customer
const setSalesOrderCustomer = function({commit, dispatch, state}, { customer, withoutLocation, withoutRep }){
  if(customer.taxable === false){
    Message.error(i18n.t('sales_orders.customerNotTaxableWarning'))
  }
  commit('SET_SALES_ORDER_CUSTOMER', customer);
  commit('SET_IND_UDPDATE_INVOICE', true);


  if(withoutLocation == null || withoutLocation === false){
    dispatch('setShippingMethod', customer.delivery_type);

    if(customer.extra_info!=null && customer.extra_info.location!=null){
      commit('SET_DELIVERY_LOCATION', customer.extra_info.location);
      commit('SET_LOCATION_NAME',customer.extra_info.location.content.number + ' - ' + customer.extra_info.location.content.address + ", " + customer.extra_info.location.content.city)
    }
  }

  dispatch('setSalesOrderBillingAddress',null);
  dispatch('setSalesOrderShippingAddress',null);

  let addresses = customer.type === 1 ? customer.company.addresses : customer.contact.addresses;
  if (addresses == null) addresses = [];


  _.forEach(addresses, adr=>{
    if(_.get(adr, 'type.code') === "BILLING"){
      dispatch('setSalesOrderBillingAddress',adr);
    }else if(_.get(adr, 'type.code')  === "SHIPPING"){
      dispatch('setSalesOrderShippingAddress',adr);
    }
  })

  if(state.salesOrder.billingAddress==null && state.salesOrder.customer.last_billing_address_id!=null){
    let address = _.find(addresses, adr => adr.id === state.salesOrder.customer.last_billing_address_id);
    dispatch('setSalesOrderBillingAddress', address);
  }

  if(state.salesOrder.shippingAddress==null && state.salesOrder.customer.last_shipping_address_id!=null){
    let address = _.find(addresses, adr=> adr.id === state.salesOrder.customer.last_shipping_address_id);
    dispatch('setSalesOrderShippingAddress',address);
  }

  if(state.salesOrder.billingAddress==null && addresses.length === 1){
    dispatch('setSalesOrderBillingAddress',addresses[0]);
  }
  if(state.salesOrder.shippingAddress==null && addresses.length === 1){
    dispatch('setSalesOrderShippingAddress',addresses[0]);
  }

  let contacts = [];
  if(customer.type === 1){
    _.forEach(customer.company.contacts, (c) => {
      if (c.active) contacts.push(c);
    })
  }else{
    contacts = [customer.contact];
  }

  let billingContact = null;
  let shippingContact = null;

  commit('SET_CUSTOMER_CONTACTS', contacts);

  if(customer.type==1){
    billingContact = _.find(state.customerContacts, c => c.default_billing_ind === true);
    shippingContact = _.find(state.customerContacts, c =>  c.default_shipping_ind === true);
  }else{
    billingContact = state.salesOrder.customer.contact;
    shippingContact = state.salesOrder.customer.contact;
  }
  //Si le billing_contact id est toujours null.. .on va chercher le dernier
  //contact a avoir été utilisé comme billing contact
  if(billingContact == null){
    billingContact = _.find(state.customerContacts, c => c.id==state.salesOrder.customer.last_billing_contact_id);
  }
  //Si le billing_contact id est toujours null.. .on va chercher le dernier
  //contact a avoir été utilisé comme billing contact
  if(shippingContact == null){
    shippingContact = _.find(state.customerContacts, c => c.id==state.salesOrder.customer.last_shipping_contact_id);
  }

  if(shippingContact == null && state.customerContacts.length==1){
    shippingContact = state.customerContacts[0]
  }

  if(billingContact == null && state.customerContacts.length==1){
    billingContact = state.customerContacts[0]
  }

  dispatch('setBillingContact',billingContact);
  dispatch('setShippingContact',shippingContact);

  if (withoutRep !== true) {
    dispatch('setSalesOrder', { rep: customer.rep })
  }

  dispatch('fetchCustomerReservation');
}

const fetchCustomerReservation = function({commit, state}){
  commit('SET_CUSTOMER_RESERVATION_LOADING',true);
  let params = {
    paging: 'no',
    customerId: [state.salesOrder.customer.id],
    available: true,
  }

  if (state.salesOrder.customer.parent != null) params.customerId.push(state.salesOrder.customer.parent.id);

  reservationAPI.fetchReservationsV2(params)
    .then(reservations=>{
      commit('SET_CUSTOMER_RESERVATION', reservations);
      commit('SET_CUSTOMER_RESERVATION_LOADING',false);
    })
}

const setBillingContact = function({ commit, state }, contact){
  commit('SET_BILLING_CONTACT', contact);
  commit('SET_IND_UDPDATE_INVOICE', true);
}

const setShippingContact = function({ commit, state }, contact){
  commit('SET_SHIPPING_CONTACT', contact);
  commit('SET_IND_UDPDATE_INVOICE', true);
}

const setDeliveryLocation = function({commit}, location){
  commit('SET_DELIVERY_LOCATION', location);
  commit('SET_LOCATION_NAME',location.content.number + ' - ' + location.content.address + ", " + location.content.city)
}

const setShippingMethod = function ({commit, dispatch}, deliveryType){
    commit('SET_SALES_ORDER_PROPERTY', {propName : 'deliveryType', propVal:deliveryType});
    if(deliveryType!=null && deliveryType.choice_custom_info!=null){
      commit('SET_SHOW_DELIVERY_LOCATION', true);
    }else{
      commit('SET_DELIVERY_LOCATION',null);
      commit('SET_SHOW_DELIVERY_LOCATION', false);
    }
}

const setSalesOrder = function({commit,dispatch}, salesOrder){
  _.forEach(['customer','billingAddress', 'shippingAddress','date','expectedDeliveryDate','shippingMethodId', 'rep','credit', 'soNumber', 'notes','reference','deliveryFee'],prop=>{
    if(salesOrder.hasOwnProperty(prop)){
      commit('SET_SALES_ORDER_PROPERTY', {propName : prop, propVal:salesOrder[prop]});

      if(prop==="credit"){
        dispatch('calculateSalesOrder');
      }
    }
  })
}
//set Billing address
const setSalesOrderBillingAddress = function({commit}, billingAddress){
  commit('SET_SALES_ORDER_BILLING_ADDRESS', billingAddress);
  commit('SET_IND_UDPDATE_INVOICE', true);
}
//Set shippping address
const setSalesOrderShippingAddress = function({commit}, shippingAddress){
  commit('SET_SALES_ORDER_SHIPPING_ADDRESS', shippingAddress);
  commit('SET_IND_UDPDATE_INVOICE', true);
}

const addDefaultItemLine = function({commit, state}){
  commit('ADD_SO_ITEM_LINE', state.defaultItem);
}

const calculateSalesOrder = function({commit, state}){
  commit('SET_DETAIL_ITEMS_LOADING', true);
  let salesOrder = {
    id: state.salesOrder.id,
    customer: {
      id: _.get(state.salesOrder, 'customer.id'),
    },
    lines : [],
    discount: state.salesOrder.discount,
  };

  _.forEach(state.salesOrder.lines, l => {
    salesOrder.lines.push({
      id: l.id,
      uuid: l.uuid,
      product: {
        id: _.get(l, 'product.id'),
        puid: _.get(l, 'product.puid'),
      },
      discount: l.discount,
      reservation: l.reservation,
      inventory: {
        id: _.get(l, 'inventory.id'),
      },
      qty: l.qty,
      prices: l.prices,
      productTaxes: l.productTaxes == null && _.get(l, 'product.taxable') === true ? _.get(l, 'product.taxes') : l.productTaxes 
    })
  })

  salesOrderApi.calculateSalesOrderV2(salesOrder)
    .then(calculatedSalesOrder=>{
      commit('SET_SUB_TOTAL', calculatedSalesOrder.subTotal);
      commit('SET_TOTAL', calculatedSalesOrder.total);
      commit('SET_TAXES', calculatedSalesOrder.taxes);
      commit('SET_GLOBAL_DISCOUNT', calculatedSalesOrder.discount);
      commit('UPDATE_ITEM_LINES', calculatedSalesOrder.lines); // a été modifié pour la V2
      commit('SET_DETAIL_ITEMS_LOADING', false);
    })
}

function isReservationAlreadyPresent(state, reservationId){
  let productFound = _.find(state.salesOrder.lines, i=>{return i.reservation != null && i.reservation.id === reservationId});
  return productFound!=null;
}
//Permet d'ajouter une ligne de produit a partir d'une réservation
// Le module de réservation doit être actif
const addReservedItemLine = function({commit, state, dispatch}, reservedItem){
  if(isReservationAlreadyPresent(state, reservedItem.id)){

    Message.error({message : "La réservation sélectionné existe déjà dans la commande. Impossible de l'ajouter de nouveau."})

  }else{
    commit('SET_DETAIL_ITEMS_LOADING', true);
    let productId = _.get(reservedItem, 'product.id');
    let puid = _.get(reservedItem, 'product.puid');
    let inventoryId = _.get(reservedItem, 'inventory.id');
    const customerId = _.get(state.salesOrder, 'customer.id');
    let reservation = _.cloneDeep(reservedItem);

    reservation.inventory = null;
    delete reservation.inventory;
    reservation.product = null;
    delete reservation.product;
    reservation.sales_rep = null;
    delete reservation.sales_rep;

    const qty = reservedItem.quantity.available < reservedItem.product.uvc ? reservedItem.quantity.available : reservedItem.product.uvc;

    return getPrice(inventoryId, puid, qty, customerId, 'puid')
      .then((calculatedProductPriceResponse) => {
        commit('ADD_ITEM_LINE_ITEM', {
          product: calculatedProductPriceResponse.product,
          inventory: calculatedProductPriceResponse.inventory,
          reservation,
          prices: calculatedProductPriceResponse.prices,
          productTaxes: calculatedProductPriceResponse.productTaxes,
          qty
        })
        commit('SET_IND_UDPDATE_INVOICE', true);
        dispatch('calculateSalesOrder')
      })
  }
}

function isItemAlreadyPresent(state, puid, id){
  let productFound = null;
  if (puid != null) {
    productFound = _.find(state.salesOrder.lines, i=>{return _.get(i, 'product.puid') === puid && i.reservation == null});
  } else {
    productFound = _.find(state.salesOrder.lines, i=>{return _.get(i, 'product.id') === id && i.reservation == null});
  }

  return productFound!=null;
}
//Permet d'ajouter une ligne de produits
// Selon la configuration MERGE_SELLING_ITEMS nous demandons le prix d'un
// produit ou d'un item d'un lot précis
// Nous validons la quantité à l'ajout avec par défaut la qty 1.
const addItemLineItem = function({commit, state, dispatch}, item){
  if(isItemAlreadyPresent(state, item.puid, item.id)){
    Message.error({message : "Le produit sélectionné existe déjà dans la commande. Impossible de l'ajouter de nouveau."})
    return Promise.resolve("AVAILABLE")
  }else{
    commit('SET_DETAIL_ITEMS_LOADING', true);
    let id = null;
    let typeId = 'puid';
    if (item.puid != null) {
      id = item.puid;
    } else {
      id = item.id;
      typeId= 'id';
    }
    let inventoryId = item.inventory!=null ? item.inventory.id : null;

    return new Promise((resolve, reject) => {
      if (inventoryId == null) {
        return getServicePrice(id, 1, state.salesOrder.customer.id, typeId)
          .then(result => resolve(result));
      }
      return getPrice(inventoryId, id, 1, state.salesOrder.customer.id, typeId)
        .then(result => resolve(result));
    })
    .then(calculatedProductPriceResponse=>{
        if (calculatedProductPriceResponse.product.type == 0) {
          commit('ADD_ITEM_LINE_ITEM',{
            product: calculatedProductPriceResponse.product,
            inventory: null,
            reservation: null,
            qty: 1,
            prices: calculatedProductPriceResponse.prices,
            productTaxes: calculatedProductPriceResponse.productTaxes
          });
          dispatch('calculateSalesOrder');
          return Promise.resolve("AVAILABLE");
        }
        else {
          if(_.get(calculatedProductPriceResponse, 'product.quantity.inStock') >= 1){

            commit('ADD_ITEM_LINE_ITEM',{
              product: calculatedProductPriceResponse.product,
              inventory: calculatedProductPriceResponse.inventory,
              reservation: calculatedProductPriceResponse.reservation,
              qty: calculatedProductPriceResponse.product.unit == 1 ? calculatedProductPriceResponse.product.uvc : 1,
              prices: calculatedProductPriceResponse.prices,
              productTaxes: calculatedProductPriceResponse.productTaxes
            });
            commit('SET_IND_UDPDATE_INVOICE', true);
            dispatch('calculateSalesOrder')
            return Promise.resolve("AVAILABLE");
          }else if(calculatedProductPriceResponse.product.quantity.pending >= 1){
            commit('SET_DETAIL_ITEMS_LOADING', false);
            return Promise.resolve("PENDING_ONLY");
          }else{
            commit('SET_DETAIL_ITEMS_LOADING', false);
            return Promise.resolve("NOT_AVAILABLE");
          }
        }


      })
  }


}

const setItemLineProp=function({commit, dispatch}, {uuid, itemProp, priceIndex}){
  _.forEach(['qty','discount','price'],prop=>{
    if(itemProp.hasOwnProperty(prop)){
      commit('SET_ITEM_LINE_PROPERTY', {uuid, propName : prop, propVal:itemProp[prop],priceIndex});
      commit('SET_IND_UDPDATE_INVOICE', true);
      if(prop=="qty" || prop=="discount" || prop=="price"){
        dispatch('calculateSalesOrder');
      }
    }
  })
}



const removeItemLine = function({commit, dispatch}, index){
  commit('REMOVE_SO_ITEM_LINE', index);
  commit('SET_IND_UDPDATE_INVOICE', true);
  dispatch('calculateSalesOrder');
}

const postSalesOrder = function({rootState,commit, state, dispatch}, action){

  // Message.success({message : "test"})
  commit('SET_LOADING',true);
  let status = getStatusFromAction(action, rootState.statuses.salesOrderStatuses,state.salesOrder);

  let postData = formatSaveSalesOrder(state.salesOrder);
  postData.status = status;

  return salesOrderApi.postSalesOrderV2(postData)
    .then(salesOrder=>{
      commit('SET_LOADING',false);
      dispatch('salesOrders/invalidateSalesOrderList',null,{root:true});
      Message.success({message : i18n.t('sales_orders.createdWithSuccess')})
      dispatch('invalidateListTags');
      return salesOrder;
    }).catch(err=>{
      commit('SET_LOADING',false);
      return Promise.reject(err);
    })
}

function confirmUpdate(salesOrder){
  if((salesOrder.packages!=null && salesOrder.packages.length>0) || salesOrder.invoiced_at!=null ){
    return MessageBox.confirm(i18n.t('sales_orders.editInstruction'), i18n.t('sales_orders.editInstructionTittle'),{confirmButtonText: 'Oui',cancelButtonText: 'Annuler'})
      .then(()=>{
        return true;
      }).catch(err=>{
        return false
      })
  }else {return Promise.resolve(true)}
}
const putSalesOrder = function({rootState, commit, state, dispatch}, action){
  commit('SET_LOADING',true);

  let status = state.salesOrder.status;

  if(action=='emit'){
    status = getStatusFromAction(action, rootState.statuses.salesOrderStatuses,state.salesOrder);
  }

  let postData = formatSaveSalesOrder(state.salesOrder);

  postData.status = status;

  return salesOrderApi.putSalesOrderV2(postData.id, postData)
    .then(salesOrder=>{
      commit('SET_LOADING',false);
      dispatch('invalidateListTags');
      return salesOrder;
    }).catch(err=>{
      commit('SET_LOADING',false);
      return Promise.reject(err);
    })

}

const reset = function({ commit }) {
  commit('RESET_STATE');
};

const transformSelectedSalesOrderToEditionMode = function({commit, dispatch}, selectedSalesOrder){
  commit('SET_LOADING',true);
  
  return dispatch('getCustomer',selectedSalesOrder.customer.id)
    .then(customer=>{
      dispatch('setSalesOrderCustomer', { customer, withoutLocation:true, withoutRep: true });
    }).then(()=>{
    
      commit('CLONE_SELECTED_SALES_ORDER',selectedSalesOrder);

      if(selectedSalesOrder.deliveryType!= null && selectedSalesOrder.deliveryType.choiceCustomInfo!=null){
        commit('SET_SHOW_DELIVERY_LOCATION',true);
          if (_.get(selectedSalesOrder, 'extraInfo.location') !=null) {
            commit('SET_DELIVERY_LOCATION', _.get(selectedSalesOrder, 'extraInfo.location'));
            commit('SET_LOCATION_NAME',selectedSalesOrder.extraInfo.location.content.number + ' - ' + selectedSalesOrder.extraInfo.location.content.address + ", " + selectedSalesOrder.extraInfo.location.content.city)
          }
          commit('SET_LOADING',false);
      }else{
        commit('SET_LOADING',false);
      }
    }).catch((err) => {
      console.log(err);
      commit('SET_LOADING',false);
    })


};

const setLocationName = function({state, commit}, locationName){
  commit('SET_LOCATION_NAME', locationName);
}




const setExtraInfo = function({state, commit}, {propName, propValue}){
  commit('SET_EXTRA_INFO_PROP', {propName, propValue});
}

const editPrice = function({commit}, {uuid, action, index}){
  commit('SET_EDIT_PRICE_FLAG', {uuid, editState:action==="show"?true:false, index});
}

const fetchTags = function({commit, state}){
  if(state.tagsOutDated){
    systemAPI.getTags('SALES_ORDER')
      .then(listTags=>{
        commit('SET_LIST_TAGS',listTags);
      })
  }
}

const invalidateListTags = function({commit}){
  commit('INVALIDATE_LIST_TAGS');
}

const setTags = function({commit},tags){
  commit('SET_TAGS', tags);
}

const getCustomer = function({commit}, customerId){
  return customerApi.getCustomer(customerId);
}

const convertSalesOrderToV1 = (salesOrderV2) => {
  const salesOrderV1 = {};
  salesOrderV1.customer = salesOrderV2.customer;
  salesOrderV1.billing_address = salesOrderV2.billingAddress;
  salesOrderV1.shipping_address = salesOrderV2.shippingAddress;
  salesOrderV1.billing_contact = salesOrderV2.billingContact;
  salesOrderV1.shipping_contact= salesOrderV2.shippingContact;
  salesOrderV1.billing_contact_id = _.get(salesOrderV2, 'billingContact.id');
  salesOrderV1.shipping_contact_id = _.get(salesOrderV2, 'shippingContact.id');
  salesOrderV1.date = salesOrderV2.date;
  salesOrderV1.expectedDeliveryDate = salesOrderV2.expectedDeliveryDate;
  salesOrderV1.delivery_fee = salesOrderV2.delivery_fee;
  salesOrderV1.delivery_type = salesOrderV2.deliveryType;
  if (salesOrderV1.delivery_type != null && salesOrderV1.delivery_type.choiceCustomInfo != null) {
    salesOrderV1.delivery_type.choice_custom_info = salesOrderV1.delivery_type.choiceCustomInfo;
    delete salesOrderV1.delivery_type.choiceCustomInfo;
  }
  salesOrderV1.extra_info = salesOrderV2.extraInfo;
  salesOrderV1.id = salesOrderV2.id;
  salesOrderV1.items = [];
  _.forEach(salesOrderV2.lines, (l) => {
    salesOrderV1.items.push({
      qty_ordered : l.qty,
      commissionAccountId: _.get(l, 'product.commissionAccount.id'),
      credit: l.credit,
      discount: l.discount,
      format: _.get(l, 'product.format'),
      inventory: l.inventory,
      inventoryId: _.get(l, 'inventory.id'),
      name: _.get(l, 'product.name'),
      prices: l.prices,
      productId: _.get(l, 'product.id'),
      provider : {
        id: _.get(l, 'product.provider.id'),
        name: _.get(l, 'product.provider.name'),
        usual_name: _.get(l, 'product.provider.usualName'),
      },
      reservation: l.reservation,
      quantityAvailable: l.quantityLeft,
      validations : l.validations,
      saleAccountId: _.get(l, 'product.saleAccount.id'),
      sku: _.get(l, 'product.sku'),
      sub_total: l.subTotal,
      sub_total_brut: l.subTotalBrut,
      taxable: _.get(l, 'product.taxable'),
      taxes: l.taxes,
      type: _.get(l, 'product.type'),
      unit: _.get(l, 'product.unit'),
      uuid: uuidv1(),
      uvc: _.get(l, 'product.uvc'),
      volume: _.get(l, 'product.volume')
    });
  });
  salesOrderV1.notes = salesOrderV2.notes;
  salesOrderV1.reference = salesOrderV2.reference;
  salesOrderV1.salesRepId = _.get(salesOrderV2, 'rep.id');
  salesOrderV1.so_number = salesOrderV2.soNumber;
  salesOrderV1.status = salesOrderV2.status;
  salesOrderV1.sub_total = salesOrderV2.subTotal;
  salesOrderV1.tags = salesOrderV2.tags;
  salesOrderV1.taxes = salesOrderV2.taxes;
  salesOrderV1.total = salesOrderV2.total;
  salesOrderV1.discount = salesOrderV2.discount;
  return salesOrderV1;
}

const initPrice = function({commit, dispatch}) {
  commit('INIT_PRICE');
  dispatch('calculateSalesOrder')
}

const duplicate = function ({commit, dispatch, state}, salesOrder){
  commit('SET_LOADING', true);
  return salesOrderApi.duplicateV2(salesOrder.id)
    .then((salesOrderV2) => {
      commit('CLONE_SELECTED_SALES_ORDER',salesOrderV2);
      return dispatch('calculateSalesOrder')
        .then(() => dispatch('getCustomer',salesOrderV2.customer.id))
    })
    .then((customer) => {
      dispatch('setSalesOrderCustomer', {customer, withoutLocation:true});
      if(_.get(state.salesOrder, 'deliveryType.choiceCustomInfo') != null){
        commit('SET_SHOW_DELIVERY_LOCATION',true);
          if(_.get(state.salesOrder, 'extraInfo.location') !=null){

            commit('SET_LOCATION_NAME', state.salesOrder.extraInfo.location.content.number + ' - ' + state.salesOrder.extraInfo.location.content.address + ", " + state.salesOrder.extraInfo.location.content.city)
          }
      }else{
        commit('SET_LOADING',false);
      }
    })
    .catch((err) => {
      console.log(err);
      Message.error(i18n.t('common.errors.generic'));
    })
}

const setGlobalDiscount = function({commit, dispatch}, discount) {
  if (discount.value === null || discount.value === 0) {
    commit('SET_GLOBAL_DISCOUNT', null);
  } else {
    commit('SET_GLOBAL_DISCOUNT', discount);
  }

  dispatch('calculateSalesOrder');
}

const removeRebates = function({commit, dispatch}, selectedLines) {
    _.forEach(selectedLines, (line) => {
      commit('SET_ITEM_LINE_PROPERTY', {
          uuid: line.uuid,
          propName: 'discount',
          propVal: {
            value:null,
            type :null,
            amount : null,
            netType : null,
            creditType : null,
          },
        }
      )
    })

    return dispatch('calculateSalesOrder');
}

const applyDiscount = function({commit, dispatch}, {discount, selectedLines}) {
  _.forEach(selectedLines, (line) => {

    commit('SET_ITEM_LINE_PROPERTY', {
      uuid: line.uuid,
      propName: 'discount',
      propVal: discount,
    })
  })
  return dispatch('calculateSalesOrder');
}

const removeLines = function({commit, dispatch, state}, selectedLines) {
    _.forEach(selectedLines, (line) => {

      const index = _.findIndex(state.salesOrder.lines, i => i.uuid === line.uuid);
      if(index != null) {
        commit('REMOVE_SO_ITEM_LINE', index);
      }

    })
    return dispatch('calculateSalesOrder');
}

export default {
  duplicate,
  fetchTags,
  fetchSearchedCustomers,
  setSalesOrderCustomer,
  setSalesOrderBillingAddress,
  setSalesOrderShippingAddress,
  addDefaultItemLine,
  setSalesOrder,
  removeItemLine,
  addItemLineItem,
  setItemLineProp,
  postSalesOrder,
  putSalesOrder,
  reset,
  fetchCustomerContacts,
  setBillingContact,
  setShippingContact,
  calculateSalesOrder,
  transformSelectedSalesOrderToEditionMode,
  fetchCustomerReservation,
  addReservedItemLine,
  validate,
  setShippingMethod,
  setDeliveryLocation,
  setLocationName,
  setExtraInfo,
  editPrice,
  setTags,
  invalidateListTags,
  getCustomer,
  initPrice,
  setGlobalDiscount,
  removeRebates,
  removeLines,
  applyDiscount
};
